export default __webpack_public_path__ + "static/media/choco-combo@2x.dc74816e.png";